export const WIDGET_SELECTOR = {
  BASKET: '#basketWidget',
  ENTRY: '.sanitasOvpEntry',
  FAB: '#fab-widget',
  PRODUCT: '.productWidget',
  SETUP: '#setupDvpWidget',
  SAVINGS: '#savingsWidget'
}